<i18n>
de:
  chooseItem: "Wähle diesen Artikel"
  chooseItems: "Wähle einen dieser Artikel"

en:
  chooseItem: "Select this item"
  chooseItems: "Choose one from these items"
</i18n>

<template>
  <div v-if="requiredPurchases.length" class="pt-10 lg:pt-0">
    <h2
      v-if="requiredPurchases.length === 1"
      class="text-secondary-400 text-2xl pb-4"
    >
      {{ $t('chooseItem') }}
    </h2>
    <h2 v-else class="text-secondary-400 text-2xl pb-4">
      {{ $t('chooseItems') }}
    </h2>
    <div class="required-purchases">
      <ItemSwiper :items="requiredPurchases" :slideCount="2" />
    </div>
  </div>
</template>

<script>
import ItemSwiper from '@/components/itemSwiper.vue'
import { sync } from 'vuex-pathify'
export default {
  props: ['requiredPurchases', 'sidebar'],
  components: { ItemSwiper },
  computed: {
    nickname: sync('reward/nickname')
  }
}
</script>
